import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class CaseServiceService {

  constructor(private httpGuard: HttpGuardService) { }

  getCaseList(pageNo: any, payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.getCaseList}/${pageNo}`, payload, true);
  }

  getCaseState(payload: any) {
    // let param = null;
    // if(payload?.dtcId) {
    //   param = '?dtcId='+payload?.dtcId;
    // }
    // if(payload?.searchKey){
    //   param = '?searchKey='+payload?.searchKey;
    // }
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getCaseStates, payload, false);
  }

  updateCaseDetails(payload: any) {
    const param = '/' + payload?.caseId;
    return this.httpGuard.httpReq('patch', 'API_ENDPOINT', `${ApiConstants.URL.updateCaseData}${param}`, payload?.data);
  }

  addComments(payload :any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.addComments, payload, false);
  }

  getCommentsList(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.commentList, payload, false);
  }

  fetchStates(payload: {module: string, fromState: string,requestor: string}) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.fetchStates, payload, false);
  }

  addProtus(payload :any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.addProtus, payload, true);
  }

  getModelsList(isMock: boolean) {
    let param = '?isMock='+ isMock;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', `${ApiConstants.URL.getModelsList}${param}`, '', false);
  }

  getProjectsList(isMock: boolean) {
    let param = '?isMock='+ isMock;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT',`${ApiConstants.URL.getprojectsList}${param}`, '', false);
  }

  checkProtusStatus(payload: {protusNumber : string}) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.protusCheck, payload, true);
  }
}
